interface EditorPanelSpareParamsEditorOptions {
	node: BaseNodeType;
}
import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {ref, Ref} from 'vue';
import {BaseNodeType} from '../../../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
export class EditorPanelSpareParamsEditorStoreControllerClass {
	private static _instance: EditorPanelSpareParamsEditorStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPanelSpareParamsEditorStoreControllerClass());
	}

	private constructor() {}

	private _nodeId: Ref<CoreGraphNodeId | null> = ref(null);

	// getters
	nodeId(): CoreGraphNodeId | null {
		// console.log(this._nodeId.value);
		return this._nodeId.value;
	}

	// mutations
	open(options: EditorPanelSpareParamsEditorOptions): void {
		this._nodeId.value = options.node.graphNodeId();
	}
	close() {
		this._nodeId.value = null;
	}
}

export const EditorPanelSpareParamsEditorStoreController = EditorPanelSpareParamsEditorStoreControllerClass.instance();
